import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-icheck';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import 'icheck/skins/all.css';

const CustomCheckbox = ({ horizontal, checkboxClass, placeholder, labelCol = 2, valueCol = 10, input: { onChange, value }, label, help, meta: { touched, error, warning }, formGroupStyle, disabled }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	let classes = checkboxClass;
	if (!checkboxClass) {
		classes = 'icheckbox_minimal-grey bg';
	}

	const formControl = <Checkbox checkboxClass={classes} increaseArea='20%' label={label} onChange={onChange} checked={!!value} disabled={disabled} />
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} style={formGroupStyle}>
				<Col smOffset={labelCol} sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState} style={formGroupStyle}>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

CustomCheckbox.propTypes = {
	horizontal: PropTypes.bool,
	checkboxClass: PropTypes.string,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	componentClass: PropTypes.string,
	value: PropTypes.string
};

export default CustomCheckbox;